import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  ProductFilterProductsDontColor,
  ProductFilterBerand,
  CompetitorPackeageSetAmountPackeage,
  CompetitorPackeageEditeAmountPackeage,
  CompetitorPackeageHistoryPackeage,
} from "../../Api/Services";
import InputCus from "../../Component/InputCus/Text/InputCus";
import ComponentPricePackeageAE from "./ComponentPricePackeageAE";
import { confirmAlert } from "react-confirm-alert";

function CompetitorPricePackeageAE() {
  const [isLoading, setLoading] = useState(true);
  const [Product, setProduct] = useState([]);
  const [Description, setDescription] = useState("");
  const [Title, setTitle] = useState("");
  const [Amounts, setAmounts] = useState([]);
  const [brands, setBrands] = useState([]);
  const [activeItem, setActiveItem] = useState(null);
  const navigate = useNavigate();
  let { id, extra } = useParams();

  const start = async () => {
    try {
      const ProductFilterProductsDontColorData =
        await ProductFilterProductsDontColor();
      if (
        ProductFilterProductsDontColorData.status &&
        ProductFilterProductsDontColorData.status === 200
      ) {
        setProduct(ProductFilterProductsDontColorData.data.data.data);
        const ProductFilterBerandData = await ProductFilterBerand({});
        if (
          ProductFilterBerandData.status &&
          ProductFilterBerandData.status === 200
        ) {
          setBrands(ProductFilterBerandData.data.data.data);

          if (extra) {
            const CompetitorPackeageHistoryPackeageData =
              await CompetitorPackeageHistoryPackeage(extra);
            if (
              CompetitorPackeageHistoryPackeageData.status &&
              CompetitorPackeageHistoryPackeageData.status === 200
            ) {
              let copy = [];
              CompetitorPackeageHistoryPackeageData.data.data.prices.map(
                (e) => {
                  let data = {
                    Id: e.productId,
                    Price: e.price,
                    Count: e.count,
                  };
                  copy.push(data);
                },
              );
              setAmounts(copy);
              setTitle(CompetitorPackeageHistoryPackeageData.data.data.title);
              setDescription(
                CompetitorPackeageHistoryPackeageData.data.data.description,
              );
            }
          }
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const handleClick = (key) => {
    setActiveItem(activeItem === key ? null : key);
  };

  function isEmpty(value) {
    return value == null || value == undefined || value == "" || value == 0;
  }

  const Add = async () => {
    let validation = true;

    let data = [...Amounts].filter(
      (item) => !(isEmpty(item.Price) && isEmpty(item.Count)),
    );
    let check = data.filter((w) => isEmpty(w.Price) || isEmpty(w.Count));
    if (check.length > 0) {
      toast.error("لطفا برای هر کالا هم قیمت هم تعداد را وارد نمایید");
      validation = false;
      return;
    }

    let checkw = data.filter((w) => {
      const product = Product.find((r) => r.id == w.Id);
      if (!product?.lastPrice) return [];
      return (
        product.lastPrice * 1.1 < w?.Price || product.lastPrice * 0.9 > w?.Price
      );
    });

    if (checkw.length > 0) {
      const dataError = [];
      checkw.forEach((element) => {
        let aa = Product.find((r) => r.id == element.Id);
        const bb = [
          aa.productBerandName != " " && aa.productBerandName + " ",

          aa.productTypeName != " " && aa.productTypeName + " ",

          aa.productSeriesName != " " && aa.productSeriesName,

          aa.symbol,

          aa.productSeriesEndName != " " ? aa.productSeriesEndName + " " : " ",

          aa.productRamName != " " && aa.productRamName + "/",

          aa.productRomName != " " && aa.productRomName + " ",

          aa.productNetworkName != " " && aa.productNetworkName + " ",

          aa.productCountryName != " " && aa.productCountryName + " ",

          aa.isInsurance && "بیمه",
        ]
          .filter(Boolean)
          .join("");

        dataError.push(bb);
      });
      validation = false;
      confirmOk(dataError);
    }
    if (validation) {
      if (extra) {
        setLoading(true);
        try {
          const CompetitorPackeageEditeAmountPackeageData =
            await CompetitorPackeageEditeAmountPackeage({
              competitorPackageId: extra,
              title: Title,
              description: Description,
              data: data,
            });
          if (
            CompetitorPackeageEditeAmountPackeageData.status &&
            CompetitorPackeageEditeAmountPackeageData.status === 200
          ) {
            toast.success("ویرایش قیمت با موفقیت انجام شد");
            navigate("/Panel/CompetitorPrice");
          }
        } catch (error) {
          console.error("Error during login:", error);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(true);
        try {
          const CompetitorPackeageSetAmountPackeageData =
            await CompetitorPackeageSetAmountPackeage({
              data: data,
              competitorId: id,
              title: Title,
              description: Description,
            });
          if (
            CompetitorPackeageSetAmountPackeageData.status &&
            CompetitorPackeageSetAmountPackeageData.status === 200
          ) {
            toast.success("افزودن  قیمت با موفقیت انجام شد");
            navigate("/Panel/CompetitorPrice");
          }
        } catch (error) {
          console.error("Error during login:", error);
        } finally {
          setLoading(false);
        }
      }
    }
  };

  const CheckOk = async () => {
    let data = [...Amounts].filter(
      (item) => !(isEmpty(item.Price) && isEmpty(item.Count)),
    );
    if (extra) {
      setLoading(true);
      try {
        const CompetitorPackeageEditeAmountPackeageData =
          await CompetitorPackeageEditeAmountPackeage({
            competitorPackageId: extra,
            title: Title,
            description: Description,
            data: data,
          });
        if (
          CompetitorPackeageEditeAmountPackeageData.status &&
          CompetitorPackeageEditeAmountPackeageData.status === 200
        ) {
          toast.success("ویرایش قیمت با موفقیت انجام شد");
          navigate("/Panel/CompetitorPrice");
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(true);
      try {
        const CompetitorPackeageSetAmountPackeageData =
          await CompetitorPackeageSetAmountPackeage({
            data: data,
            competitorId: id,
            title: Title,
            description: Description,
          });
        if (
          CompetitorPackeageSetAmountPackeageData.status &&
          CompetitorPackeageSetAmountPackeageData.status === 200
        ) {
          toast.success("افزودن  قیمت با موفقیت انجام شد");
          navigate("/Panel/CompetitorPrice");
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const confirmOk = (products) => {
    confirmAlert({
      title: "ایا از انجام این کار مطمئن هستید ",
      message: (
        <>
          <p>کالاهای زیر قیمت خارج از بازه خواهند داشت:</p>

          <ul>
            {products.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </>
      ),
      buttons: [
        {
          label: "بله",
          onClick: () => {
            CheckOk();
          },
        },
        {
          label: "خیر",
        },
      ],
    });
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="d-flex justify-content-end align-items-center m-2 w-100">
            <button onClick={Add} className="butAU">
              {extra ? "ویرایش" : "افزودن"}
            </button>
          </div>
          <div className="d-flex justify-content-start align-items-center flex-column m-2 w-100">
            <InputCus
              className="m-2"
              type="text"
              name="Title"
              id="Title"
              text="نام"
              value={Title}
              onChange={(w) => {
                setTitle(w.target.value);
              }}
            />
            <InputCus
              className="m-2"
              type="text"
              name="Description"
              id="Description"
              text="توضیحات"
              value={Description}
              onChange={(w) => {
                setDescription(w.target.value);
              }}
            />
          </div>

          {brands.map(
            (b, key) =>
              Product.filter((e) => e.productBerandId == b.id).length > 0 && (
                <>
                  <div
                    key={b}
                    className="d-flex justify-content-around align-items-center w-100 p-3 mt-4 pointer bg-body-secondary border border-1 border-black"
                    onClick={() => handleClick(b.id)}
                  >
                    <h5>{b.name}</h5>
                  </div>
                  {activeItem === b.id && (
                    <ComponentPricePackeageAE
                      key={key}
                      Product={Product.filter((e) => e.productBerandId == b.id)}
                      Amounts={Amounts}
                      setAmounts={setAmounts}
                    />
                  )}
                </>
              ),
          )}

          <div className="d-flex justify-content-start align-items-center w-100 m-5">
            <button onClick={Add} className="butAU">
              {extra ? "ویرایش" : "افزودن"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompetitorPricePackeageAE;
